import React, { Component } from "react";
import { Field } from "redux-form";

import userActivities from "../../constants/userActivities.js";
import Loader from "../shared/Loader";

class UserForm extends Component {
  render() {
    const { error, handleSubmit, submitting } = this.props;

    return (
      <form onSubmit={handleSubmit} className="">
        {error && <div className="error">{error}</div>}

        {/* gender */}
        <div className="mb2">
          <div className="radio__field">
            <Field
              id="male"
              name="gender"
              component="input"
              type="radio"
              value="male"
              checked="checked"
            />
            <label htmlFor="male">{this.props.t("account:civilityMrSign")}</label>
          </div>
          <div className="radio__field">
            <Field
              id="female"
              className="form__field"
              name="gender"
              component="input"
              type="radio"
              value="female"
            />
            <label htmlFor="female">{this.props.t("account:civilityMrsSign")}</label>
          </div>
        </div>

        {/* lastname */}
        <Field
          className="form__field"
          name="lastname"
          component="input"
          type="text"
          placeholder={this.props.t("account:lastNameSign")}
        />

        {/* firstname */}
        <Field
          className="form__field"
          name="firstname"
          component="input"
          type="text"
          placeholder={this.props.t("account:firstNameSign")}
        />

        {/* company */}
        <Field
          className="form__field"
          name="company"
          component="input"
          type="text"
          placeholder={this.props.t("account:companyNameSign")}
        />

        {/* activity */}
        <Field
          className="form__field"
          name="activity"
          component="select"
          placeholder={this.props.t("account:activity")}
        >
          {userActivities.map((activity, id) => {
            return (
              <option key={id} value={activity.id}>
                  {this.props.t("userActivities:activity" + activity.id + "title")}
              </option>
            );
          })}
        </Field>

        {/* address */}
        <Field
          className="form__field"
          name="address"
          component="textarea"
          placeholder={this.props.t("account:addressSign")}
        />

        {/* city / postal code */}
        <Field
          className="form__field"
          name="postalCode"
          component="input"
          type="text"
          placeholder={this.props.t("account:postCodeSign")}
        />
        <Field
          className="form__field"
          name="city"
          component="input"
          type="text"
          placeholder={this.props.t("account:citySign")}
        />

        {/* country */}
        <Field
          className="form__field"
          name="country"
          component="input"
          type="text"
          placeholder={this.props.t("account:countrySign")}
        />

        {/* email */}
        <Field
          className="form__field"
          name="email"
          component="input"
          type="email"
          placeholder={this.props.t("account:emailAddressSign")}
        />

        {/* password */}
        <Field
          className="form__field form__field--with-hint"
          name="password"
          component="input"
          type="password"
          placeholder={this.props.t("account:passwordSign")}
        />
        <div className="form__hint">
          ({this.props.t("account:emptyLabel")})
        </div>

        {/* new password */}
        <Field
          className="form__field form__field--with-hint"
          name="newPassword"
          component="input"
          type="password"
          placeholder={this.props.t("account:newPasswordSign")}
        />
        <div className="form__hint">
          ({this.props.t("account:emptyLabel")})
        </div>

        {/* new password confirmation */}
        <Field
          className="form__field form__field--with-hint"
          name="newPasswordConfirmation"
          component="input"
          type="password"
          placeholder={this.props.t("account:newPasswordConfirmSign")}
        />
        <div className="form__hint">
          ({this.props.t("account:emptyLabel")})
        </div>
        <div className="form__hint">
        {this.props.t("account:requiredSign")}
        </div>
        <div className="mt3 tc">
          {submitting ? (
            <Loader button />
          ) : (
            <button className="button" type="submit">
              {this.props.t("common:saveButton")} &#8594;
            </button>
          )}
        </div>

      </form>
    );
  }
}

export default UserForm;



// WEBPACK FOOTER //
// ./src/components/forms/UserForm.js